import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./GroupPluginList.module.css";
import GroupPluginItem from "../GroupPluginItem";
import RemovePluginModal from "../RemovePluginModal";

/**
 * Interactive component. List of plugins with a header.
 */
export function GroupPluginList({ plugins }) {
  const [removeModalOpen, setRemoveModalOpen] = useState(false);
  const [noRefresh, setNoRefresh] = useState(false);
  const [notSync, setNotSync] = useState(false);

  const groupPlugins = {
    id: "123",
    name: "First Name Last Name",
    pluggedInto: "1234567",
    date: "02/24/2020",
    time: "11:01:01",
  };

  function handleRemove(checked) {
    if (noRefresh === checked) {
      setNoRefresh(!noRefresh);
    }
    if (notSync === checked) {
      setNotSync(!notSync);
    }
    setRemoveModalOpen(false);
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.headerGrid}>
          <div className={styles.headerItem}>ID</div>
          {/* <div className={styles.headerItem}>Dreamstream ID</div> */}
          <div className={styles.headerItem}>User ID</div>
          <div className={styles.headerItem}>Group ID</div>
          <div className={styles.headerItem}>As Admin</div>
          <div className={styles.headerItem}>Status</div>
          <div className={styles.headerItem}>Created On</div>
          <div className={styles.headerItem}>Details</div>
        </div>

        <div className={styles.pluginContainer}>
          {plugins.map((plugin, index) => (
            <div
              className={
                index % 2 === 0 ? styles.backgroundWhite : styles.backgroundGray
              }
            >
              <GroupPluginItem
                pluginInfo={{
                  id: plugin.id,
                  dsId: plugin.dsId,
                  userId: plugin.userId,
                  groupId: plugin.groupId,
                  asAdmin: plugin.asAdmin,
                  status: plugin.status,
                  date: plugin.date,
                  time: plugin.time,
                  details: plugin.details,
                }}
                onRemove={() => {
                  setRemoveModalOpen(true);
                }}
              />
            </div>
          ))}
        </div>

        <RemovePluginModal
          type={"REMOVE GROUP PLUGIN"}
          isOpen={removeModalOpen}
          doNotSync={notSync}
          withoutRefresh={noRefresh}
          pluginInfo={groupPlugins}
          onClose={() => setRemoveModalOpen(false)}
          onClick={() => alert("Remove clicked")}
          // onClick={handleRemove}
        />
      </div>
    </>
  );
}

GroupPluginList.propTypes = {
  plugins: PropTypes.arrayOf(PropTypes.object),
};
